// extracted by mini-css-extract-plugin
export default {"price":"Exchange_price__Qxy4F","pTable":"Exchange_pTable__vFdg+"};